import type React from 'react';

import { Wrapper } from './wrapper';

interface Props {
  children: React.ReactNode;
  noMaxWidth?: boolean;
}

const Container = ({ children, noMaxWidth }: Props) => (
  <Wrapper $noMaxWidth={noMaxWidth}>{children}</Wrapper>
);

export default Container;
